import React, { useEffect, useState } from "react";
import styles from "../styles/bookingstyle.module.css";

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import koLocale from 'date-fns/locale/ko'
import TextField from '@mui/material/TextField';
import { DatePicker } from "@mui/x-date-pickers";

import { Button, Checkbox, FormControl, Radio, Tab, TabList, Tabs } from "@mui/joy";
import { RadioGroup } from "@mui/joy";

const ampm = [600, 630, 660, 690, 720, 750, 780, 810, 840, 870, 900, 930, 960, 990, 1020, 1050, 1080, 1110, 1140, 1170, 1200, 1230, 1260, 1290];

const BlockBookingTime: React.FC<any> = (props) => {

    const [dateValue, setDateValue] = useState(new Date());
    const [selectedKind, setSelectedKind] = useState<any>("0");
    const [selectedLocation, setSelectedLocation] = useState<string>("gangnam"); 
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {

        // var isToday = false;

        // const today = new Date();

        // const realSelectedDay = {
        //     year: dateValue.getFullYear(),
        //     month: dateValue.getMonth(),
        //     date: dateValue.getDate(),
        //     day: dateValue.getDay()
        // }

        // if (today.getFullYear() === realSelectedDay.year && today.getMonth() === realSelectedDay.month && today.getDate() === realSelectedDay.date) {
        //     console.log("today");
        //     isToday = true;
        // }

        // const select = parseInt(selectedKind);

        // if (select === 0 || select === 1 || select === 2) {

        //     setLoading(true);

        //     fetch(`https://suneungsunbae.com/api/booking?select=${select}&year=${realSelectedDay.year}&month=${realSelectedDay.month}&date=${realSelectedDay.date}`, {
        //         method: "GET"
        //     }).then((response: any) => {
        //         response.json()
        //             .then((result: any) => {

        //                 console.log(result);

        //                 const occupiedTimeData: any = [];
        //                 const occupiedTimeKind: any = [];

        //                 const axiosData = result.axiosData;

        //                 var selectedData : any ;

        //                 axiosData.forEach((eachData: any) => {
        //                     if(eachData.location === location && eachData.kind === select){
        //                         selectedData = eachData;
        //                     }
        //                 });

        //                 result.data.forEach((eachData: any) => {

        //                     if(location !== eachData.location){
        //                         return;
        //                     }

        //                     //관리자가 누른 경우. kind에 따라 각자 막힘
        //                     if(eachData.name === "관리자"){
        //                         if(eachData.kind === select){
        //                             occupiedTimeData.push(eachData.time);
        //                             occupiedTimeKind.push(eachData.kind);
        //                         }
        //                     }else{
        //                         //고객이 누른 경우 kind에 관계 없이 막힘
        //                         occupiedTimeData.push(eachData.time);
        //                         occupiedTimeKind.push(eachData.kind);
        //                     }
        //                 })


        //                 const newAmPm: any = [];

        //                 const currentTime = today.getHours() * 60 + today.getMinutes();

        //                 ampm.forEach((eachTime: number) => {
        //                     const oneRow: any = {};
        //                     oneRow.time = eachTime;
        //                     oneRow.ampm = "pm";
        //                     if (eachTime <= 690) {
        //                         oneRow.ampm = "am";
        //                     }
        //                     //oneRow.possible = true;
        //                     if (occupiedTimeData.includes(eachTime) 
        //                     //|| occupiedTimeData.includes(eachTime - 30)
        //                 ) {
        //                         oneRow.possible = false;
        //                     }
        //                     oneRow.isPast = false;
        //                     if (isToday) {
        //                         if (oneRow.time < currentTime + 60) {
        //                             oneRow.isPast = true;
        //                         }
        //                     }
        //                     newAmPm.push(oneRow);
        //                 });

                        


        //                 //am 갯수 아예 없으면 빼버리는 기능-----------------
        //                 var amCount = 0;
        //                 var pmCount = 0;

        //                 if (isToday) {
        //                 } else {
        //                     amCount = 1;
        //                     pmCount = 1;
        //                 }

        //                 newAmPm.forEach((eachTime: any) => {
        //                     if (eachTime.ampm === "am" && !eachTime.isPast) {
        //                         amCount++
        //                     }
        //                     if (eachTime.ampm === "pm" && !eachTime.isPast) {
        //                         pmCount++;
        //                     }
        //                 });


        //                 //--------------------------------------------------------------------
        //                 if(realSelectedDay.day >= 0 && realSelectedDay.day < 6){
        //                     newAmPm.forEach((eachTime: any) => {
        //                         if (eachTime.time >= 1200) {
        //                             eachTime.possible = false;
        //                         }
        //                     })
        //                 }



        //                 //특정 시간만 넣는 기능--------------------------------------------------

        //                 var isSaturday = realSelectedDay.day === 6 ? true : false;

        //                 var isSunday = realSelectedDay.day === 0 ? true : false;

        //                 newAmPm.forEach((eachTime: any) => {
        //                     eachTime.possible = false;
        //                 })

        //                 console.log(selectedData);

        //                 if (selectedData) {

        //                     newAmPm.forEach((eachTime: any) => {

        //                         if (!isSaturday && !isSunday) {

        //                             const selectedTimes = selectedData.time.weekdays;

        //                             if(selectedTimes.includes(eachTime.time)){
        //                                 eachTime.possible = true;
        //                             }

        //                         } else if (isSaturday) {

        //                             const selectedTimes = selectedData.time.saturday;

        //                             if(selectedTimes.includes(eachTime.time)){
        //                                 eachTime.possible = true;
        //                             }

        //                         } else if (isSunday) {

        //                             const selectedTimes = selectedData.time.sunday;

        //                             if(selectedTimes.includes(eachTime.time)){
        //                                 eachTime.possible = true;
        //                             }

        //                         }

        //                     })

        //                 }

        //                 newAmPm.forEach((eachTime: any) => {
        //                     if(occupiedTimeData.includes(eachTime.time)){
        //                         eachTime.possible = false;
        //                     }
        //                 });

        //                 console.log(newAmPm);
        //                 // setTimeData(newAmPm);

        //             })
        //         setLoading(false);
        //     })
        // } 

    }, [dateValue, selectedKind, selectedLocation]);


    return (
        <div>
            <div className={styles.radioTitle}>
                - 날짜를 선택해주세요
            </div>
            <div>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <LocalizationProvider locale={koLocale} dateAdapter={AdapterDateFns}>
                        <DatePicker
                            disablePast
                            value={dateValue}
                            onChange={(newValue: any) => {
                                setDateValue(newValue);
                            }}
                            renderInput={(params: any) => <TextField {...params} />}
                        />
                    </LocalizationProvider>
                </div>
            </div>
            <div className={styles.radioTitle}>
                - 어떤 종류의 상담을 관리하고 싶으신가요?
            </div>
            <div>
                <FormControl>
                    <RadioGroup
                        orientation="horizontal"
                        value={selectedKind}
                        onChange={(e) => {
                            setSelectedKind(e.target.value);
                        }}
                    >
                        <Radio size="lg" value={"0"} label={<span className={styles.radiofont}>방문상담</span>} />
                        <Radio size="lg" value={"1"} label={<span className={styles.radiofont}>전화상담</span>} />
                    </RadioGroup>
                </FormControl>
            </div>
            <div className={styles.radioTitle}>
                - 어느 지점을 관리하고 싶으신가요?
            </div>
            <div>
                <FormControl>
                    <RadioGroup
                        orientation="horizontal"
                        value={selectedLocation}
                        onChange={(e) => {
                            setSelectedLocation(e.target.value);
                        }}
                    >
                        <Radio size="lg" value="gangnam" label={<span className={styles.radiofont}>강남점</span>} />
                        <Radio size="lg" value="daechi" label={<span className={styles.radiofont}>대치점</span>} />
                        <Radio size="lg" value="bundang" label={<span className={styles.radiofont}>분당점</span>} />
                        <Radio size="lg" value="songpa" label={<span className={styles.radiofont}>송파점</span>} />
                    </RadioGroup>
                </FormControl>
            </div>
            <div className={styles.radioTitle}>
                - 상담을 닫고 싶은 시간을 선택해주세요
            </div>

        </div>
    )

}

export default BlockBookingTime;